import classnames from '../../node_modules/classnames/index.js';
import { Children, cloneElement, createElement } from 'react';
import { __assign } from '../../node_modules/tslib/tslib.es6.js';

/**
 * Adds a class name to all given React children that support it.
 * The class name is merged with any existing value.
 *
 * This function can be used for components that need to control
 * the appearance of their children without adding extra wrapper
 * elements, e.g. animation components that apply transition classes.
 */
var addClassNameToChildren = function (children, className, style) {
    return Children.map(children, function (child) {
        if (child && typeof child === "object" && "props" in child) {
            return cloneElement(child, {
                className: classnames(child.props.className, className),
                style: __assign(__assign({}, child.props.style), style),
            });
        }
        return child;
    });
};
/**
 * Wraps all children that are of type string in a <span> element.
 */
var wrapTextInSpan = function (children) {
    return Children.map(children, function (child) {
        if (typeof child === "string") {
            return createElement("span", {}, [child]);
        }
        return child;
    });
};

export { addClassNameToChildren, wrapTextInSpan };
